import React from 'react';

// 简单分页条：当前演示数据默认只有一页，后续接接口时可以扩展 current/pageSize。
export default function Pagination({ count }) {
  return (
    <div className="flex justify-between items-center mt-5 text-[13px] text-gray-500">
      <div>共 <span className="font-bold text-gray-700 mx-1">{count}</span> 条记录</div>
      <div className="flex space-x-1 items-center">
        <button className="px-2 py-1 border border-gray-300 rounded hover:bg-gray-50 disabled:bg-gray-100 disabled:text-gray-400" disabled>&lt;</button>
        <button className="px-3 py-1 bg-[#1890ff] text-white rounded">1</button>
        <button className="px-2 py-1 border border-gray-300 rounded hover:bg-gray-50">&gt;</button>
        <span className="ml-2">前往</span>
        <input type="text" defaultValue="1" className="w-10 border border-gray-300 rounded px-1.5 py-1 text-center outline-none focus:border-[#1890ff] mx-1" />
        <span>页</span>
      </div>
    </div>
  );
}
